/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
    let languageSelector;
    const languageSelectorSelector = ".language-selector";
    const visibleClass = "language-selector--visible";

    const toggleLanguageSelector = function(languageSelector,forceClose = false) {
        if(languageSelector != null) {
            if(forceClose) {
                languageSelector.classList.remove(visibleClass);
            }else if(!languageSelector.classList.contains(visibleClass)) {
                languageSelector.classList.add(visibleClass);
            }else {
                languageSelector.classList.remove(visibleClass);
            }
        }
    }

    const init = function () {
        languageSelector = document.querySelector(languageSelectorSelector);
        if(languageSelector != null) {
            languageSelector.querySelector('.language-selector__current').addEventListener('click', e => {
                const languageSelectorElement = e.target.closest(languageSelectorSelector);
                toggleLanguageSelector(languageSelectorElement);
            });

            document.addEventListener('click',e => {
                if(e.target.className.includes('language-selector')) {
                    return false;
                }
                const languageSelector = document.querySelector(languageSelectorSelector);
                if(languageSelector != null) {
                    toggleLanguageSelector(languageSelector,true);
                }
            })
        }
    };

    init();
}

